/* Angel Haven — animated starfield (black & white, gentle drift + twinkle) */
(function () {
  var canvas = document.getElementById('ah-starfield');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var stars = [];
  var w, h, dpr;

  function resize() {
    dpr = window.devicePixelRatio || 1;
    w = canvas.clientWidth;
    h = canvas.clientHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    seed();
  }

  function seed() {
    var count = Math.min(160, Math.floor((w * h) / 9000));
    stars = [];
    for (var i = 0; i < count; i++) {
      stars.push({
        x: Math.random() * w,
        y: Math.random() * h,
        r: Math.random() * 1.2 + 0.2,
        a: Math.random(),
        tw: Math.random() * 0.02 + 0.004,
        vy: Math.random() * 0.06 + 0.01
      });
    }
  }

  function draw() {
    ctx.clearRect(0, 0, w, h);
    for (var i = 0; i < stars.length; i++) {
      var s = stars[i];
      s.a += s.tw;
      var alpha = 0.3 + Math.abs(Math.sin(s.a)) * 0.7;
      s.y += s.vy;
      if (s.y > h) { s.y = 0; s.x = Math.random() * w; }
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,' + alpha.toFixed(3) + ')';
      ctx.fill();
    }
    requestAnimationFrame(draw);
  }

  window.addEventListener('resize', resize);
  resize();
  requestAnimationFrame(draw);
})();
